import React from 'react';
import './VideoModal.css';

const VideoModal = ({ show, handleClose, videoSrc }) => {
  return (
    <div className={`modal ${show ? 'show' : ''}`} onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <span className="close" onClick={handleClose}>&times;</span>
        <iframe 
          width="100%" 
          height="400" 
          src={videoSrc} 
          title="Video player" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default VideoModal;
